// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Contact from "./contact.js"
import Gender from "./gender.js"
import Organization from "./organization.js"
import PersonRole from "./person-role.js"
import Role from "./role.js"
import SchoolClass from "./school-class.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "anonymous": {
      "column": {
        "default": false,
        "name": "anonymous",
        "null": false,
        "type": "boolean"
      },
      "name": "anonymous",
      "selected_by_default": null,
      "translated": null
    },
    "birthday": {
      "column": {
        "default": null,
        "name": "birthday",
        "null": true,
        "type": "date"
      },
      "name": "birthday",
      "selected_by_default": null,
      "translated": null
    },
    "deleted_at": {
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      },
      "name": "deleted_at",
      "selected_by_default": null,
      "translated": null
    },
    "first_name": {
      "column": {
        "default": null,
        "name": "first_name",
        "null": true,
        "type": "string"
      },
      "name": "first_name",
      "selected_by_default": null,
      "translated": null
    },
    "gender_id": {
      "column": {
        "default": null,
        "name": "gender_id",
        "null": true,
        "type": "uuid"
      },
      "name": "gender_id",
      "selected_by_default": null,
      "translated": null
    },
    "kmd_identifier": {
      "column": {
        "default": null,
        "name": "kmd_identifier",
        "null": true,
        "type": "string"
      },
      "name": "kmd_identifier",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "last_name": {
      "column": {
        "default": null,
        "name": "last_name",
        "null": true,
        "type": "string"
      },
      "name": "last_name",
      "selected_by_default": null,
      "translated": null
    },
    "tea_identifier": {
      "column": {
        "default": null,
        "name": "tea_identifier",
        "null": true,
        "type": "integer"
      },
      "name": "tea_identifier",
      "selected_by_default": null,
      "translated": null
    },
    "uni_id": {
      "column": {
        "default": null,
        "name": "uni_id",
        "null": true,
        "type": "string"
      },
      "name": "uni_id",
      "selected_by_default": null,
      "translated": null
    },
    "danish_cpr": {
      "column": {
        "default": null,
        "name": "danish_cpr",
        "null": true,
        "type": "integer"
      },
      "name": "danish_cpr",
      "selected_by_default": false,
      "translated": null
    },
    "profile_image_path": {
      "column": null,
      "name": "profile_image_path",
      "selected_by_default": false,
      "translated": null
    },
    "required_metadatum_id": {
      "column": null,
      "name": "required_metadatum_id",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Person",
  "collectionKey": "people",
  "collectionName": "people",
  "i18nKey": "person",
  "camelizedLower": "person",
  "name": "Person",
  "nameDasherized": "person",
  "pluralName": "people",
  "ransackable_associations": [
    {
      "className": "Ability",
      "collectionName": "abilities",
      "foreignKey": "ability_id",
      "name": "abilities",
      "macro": "has_many",
      "resource_name": "Ability",
      "through": "roles"
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "has_one",
      "resource_name": "ClassStep",
      "through": "current_school_year"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "person_id",
      "name": "contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "contact_id",
      "name": "current_school_year",
      "macro": "has_one",
      "resource_name": "SchoolYear",
      "through": "contact"
    },
    {
      "className": "SchoolYear",
      "collectionName": "school_years",
      "foreignKey": "contact_id",
      "name": "current_school_years",
      "macro": "has_many",
      "resource_name": "SchoolYear",
      "through": "contact"
    },
    {
      "className": "Email",
      "collectionName": "emails",
      "foreignKey": "contact_id",
      "name": "emails",
      "macro": "has_many",
      "resource_name": "Email",
      "through": "contact"
    },
    {
      "className": "Gender",
      "collectionName": "genders",
      "foreignKey": "gender_id",
      "name": "gender",
      "macro": "belongs_to",
      "resource_name": "Gender",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PersonRole",
      "collectionName": "person_roles",
      "foreignKey": "person_id",
      "name": "person_roles",
      "macro": "has_many",
      "resource_name": "PersonRole",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "profile_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "profile_image_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "profile_image_attachment"
    },
    {
      "className": "Role",
      "collectionName": "roles",
      "foreignKey": "role_id",
      "name": "roles",
      "macro": "has_many",
      "resource_name": "Role",
      "through": "person_roles"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "current_school_year"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "current_school_year"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "organization_id",
      "name": "school_contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "school"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "school_region",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "school_contact"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "person_id",
      "name": "user",
      "macro": "has_one",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "anonymous",
      "column": {
        "default": false,
        "name": "anonymous",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "birthday",
      "column": {
        "default": null,
        "name": "birthday",
        "null": true,
        "type": "date"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "danish_cpr",
      "column": {
        "default": null,
        "name": "danish_cpr",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "deleted_at",
      "column": {
        "default": null,
        "name": "deleted_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "deprecated_class_name",
      "column": {
        "default": null,
        "name": "deprecated_class_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "deprecated_class_step_id",
      "column": {
        "default": null,
        "name": "deprecated_class_step_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "deprecated_school_class_id",
      "column": {
        "default": null,
        "name": "deprecated_school_class_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "deprecated_school_id",
      "column": {
        "default": null,
        "name": "deprecated_school_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "first_name",
      "column": {
        "default": null,
        "name": "first_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "gender_id",
      "column": {
        "default": null,
        "name": "gender_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "kmd_identifier",
      "column": {
        "default": null,
        "name": "kmd_identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "last_name",
      "column": {
        "default": null,
        "name": "last_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "old_gender_id",
      "column": {
        "default": null,
        "name": "old_gender_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tea_identifier",
      "column": {
        "default": null,
        "name": "tea_identifier",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "uni_id",
      "column": {
        "default": null,
        "name": "uni_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "person_id",
      "name": "contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Gender",
      "collectionName": "genders",
      "foreignKey": "gender_id",
      "name": "gender",
      "macro": "belongs_to",
      "resource_name": "Gender",
      "through": null
    },
    {
      "className": "PersonRole",
      "collectionName": "person_roles",
      "foreignKey": "person_id",
      "name": "person_roles",
      "macro": "has_many",
      "resource_name": "PersonRole",
      "through": null
    },
    {
      "className": "Role",
      "collectionName": "roles",
      "foreignKey": "role_id",
      "name": "roles",
      "macro": "has_many",
      "resource_name": "Role",
      "through": "person_roles"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "current_school_year"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "current_school_year"
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "person_id",
      "name": "user",
      "macro": "has_one",
      "resource_name": "User",
      "through": null
    }
  ],
  "paramKey": "person",
  "primaryKey": "id"
}

/** Frontend model for Person. */
export default class Person extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  anonymous() {
    return this.readAttributeUnderscore("anonymous")
  }

  /** @returns {boolean} */
  hasAnonymous() {
    const value = this.anonymous()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  birthday() {
    return this.readAttributeUnderscore("birthday")
  }

  /** @returns {boolean} */
  hasBirthday() {
    const value = this.birthday()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  deletedAt() {
    return this.readAttributeUnderscore("deleted_at")
  }

  /** @returns {boolean} */
  hasDeletedAt() {
    const value = this.deletedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  firstName() {
    return this.readAttributeUnderscore("first_name")
  }

  /** @returns {boolean} */
  hasFirstName() {
    const value = this.firstName()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  genderId() {
    return this.readAttributeUnderscore("gender_id")
  }

  /** @returns {boolean} */
  hasGenderId() {
    const value = this.genderId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  kmdIdentifier() {
    return this.readAttributeUnderscore("kmd_identifier")
  }

  /** @returns {boolean} */
  hasKmdIdentifier() {
    const value = this.kmdIdentifier()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  lastName() {
    return this.readAttributeUnderscore("last_name")
  }

  /** @returns {boolean} */
  hasLastName() {
    const value = this.lastName()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  teaIdentifier() {
    return this.readAttributeUnderscore("tea_identifier")
  }

  /** @returns {boolean} */
  hasTeaIdentifier() {
    const value = this.teaIdentifier()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  uniId() {
    return this.readAttributeUnderscore("uni_id")
  }

  /** @returns {boolean} */
  hasUniId() {
    const value = this.uniId()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  danishCpr() {
    return this.readAttributeUnderscore("danish_cpr")
  }

  /** @returns {boolean} */
  hasDanishCpr() {
    const value = this.danishCpr()

    return this._isPresent(value)
  }

  /** @returns {any} */
  profileImagePath() {
    return this.readAttributeUnderscore("profile_image_path")
  }

  /** @returns {boolean} */
  hasProfileImagePath() {
    const value = this.profileImagePath()

    return this._isPresent(value)
  }

  /** @returns {any} */
  requiredMetadatumId() {
    return this.readAttributeUnderscore("required_metadatum_id")
  }

  /** @returns {boolean} */
  hasRequiredMetadatumId() {
    const value = this.requiredMetadatumId()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static validSchools(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "valid_schools",
        collectionName: "people",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  createUser(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "create_user",
        primaryKey: this.primaryKey(),
        collectionName: "people",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readHasOneReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["person_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./gender.js").default | null} */
  gender() {
    return this._readBelongsToReflection({modelClass: Gender, reflectionName: "gender"})
  }

  /** @returns {Promise<import("./gender.js").default | null>} */
  loadGender() {
    if (!("genderId" in this)) throw new Error("Foreign key method wasn't defined: genderId")

    const id = this.genderId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "gender",
        model: this,
        modelClass: Gender
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./gender.js").default | null>} */
  ensureGenderLoaded() {
    return this.ensureAssociationLoaded("gender")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./person-role.js").default>} */
  personRoles() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["person_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "person_roles",
        model: this,
        modelClass: PersonRole
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./person-role.js").default>>} */
  loadPersonRoles() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["person_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "person_roles",
        model: this,
        modelClass: PersonRole
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./person-role.js").default>>} */
  ensurePersonRolesLoaded() {
    return this.ensureAssociationLoaded("person_roles")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./role.js").default>} */
  roles() {
    return new Collection(
      {
        reflectionName: "roles",
        model: this,
        modelClass: Role
      },
      {
        params: {
          through: {
            model: "Person",
            id: this.primaryKey(),
            reflection: "roles"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./role.js").default>>} */
  loadRoles() {
    return this._loadHasManyReflection(
      {
        reflectionName: "roles",
        model: this,
        modelClass: Role
      },
      {
        params: {
          through: {
            model: "Person",
            id: this.primaryKey(),
            reflection: "roles"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./role.js").default>>} */
  ensureRolesLoaded() {
    return this.ensureAssociationLoaded("roles")
  }

  /** @returns {import("./organization.js").default | null} */
  school() {
    return this._readHasOneReflection({modelClass: Organization, reflectionName: "school"})
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  loadSchool() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "school",
        model: this,
        modelClass: Organization
      },
      {
        params: {
          through: {
            model: "Person",
            id,
            reflection: "school"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  ensureSchoolLoaded() {
    return this.ensureAssociationLoaded("school")
  }

  /** @returns {import("./school-class.js").default | null} */
  schoolClass() {
    return this._readHasOneReflection({modelClass: SchoolClass, reflectionName: "school_class"})
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  loadSchoolClass() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "school_class",
        model: this,
        modelClass: SchoolClass
      },
      {
        params: {
          through: {
            model: "Person",
            id,
            reflection: "school_class"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./school-class.js").default | null>} */
  ensureSchoolClassLoaded() {
    return this.ensureAssociationLoaded("school_class")
  }

  /** @returns {import("./user.js").default | null} */
  user() {
    return this._readHasOneReflection({modelClass: User, reflectionName: "user"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadUser() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["person_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "user",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureUserLoaded() {
    return this.ensureAssociationLoaded("user")
  }
}
